import tr from './tr.json';
import en from './en.json';

/**
 * The i18next namespace these blocks read. It is `@akademi/site-builder-blocks`' own, so a block
 * moved between the two packages kept its strings.
 */
export const NS = 'site-builder-blocks';

/**
 * Strings for this package's blocks, all under one top-level key, `commerce`, that
 * `@akademi/site-builder-blocks` does not use. A host merges this fragment with that package's
 * `locales` one level deep, so a shared top-level key would replace one side's strings; the
 * package test fails if the two ever share one.
 */
export const locales = [{ ns: NS, resources: { tr, en } }];
